<template>
  <div class="about">
	  <headerPage></headerPage>
	  <div class="content">
		  <div class="about-content">
			  <div class="about-desc">
				<div style="font-weight:bold">智能+学院</div>
				<div>中国信通院“智能+学院”是中国信息通信研究院于2019年联合工业互联网产业联盟、北京航空航天大学发起的新型教育平台，已成为各行业数字化转型升级的重要合作伙伴，已经有近6000位学员从“智能+学院”获得结业证书。“智能+学院”是一个开放性的“赋能赋智赋值”平台，师资力量雄厚，并注重国际化策略，希望能为中国数字经济发展贡献力量。“智能+学院”以为工业互联网、5G、AI、区块链等领域培养更多优秀从业者为目标，依托国家顶级节点、星火链网为代表的国家新型基础设施，面向产业数字化转型，从理念、技术、到场景和经营实践设计课程体系，并通过线上平台、线下仿真、实训基地等方式加速技术落地和产业创新。
        </div>

				<div></div>
			  </div>
			  <img style="width:59%;height:100%;object-fit:contain" src="../../assets/image/logo.png">
		  </div>
	  </div>
  </div>
</template>

<script>
  import headerPage from "../../components/header/header"
  export default {
	data() {
	  return{

	  }
	},
	components: {
		headerPage,
	},
	methods: {


	},
	created() {

	},
	mounted() {

	}
 }
</script>

<style scoped>
@import url("../../assets/css/about/about.css");
</style>
